module.exports = __webpack_public_path__ + "img/6.d45d5fc3.png";